import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'has_facility_acted_against_legal_requirements_hiring_temporary'

export const dataPointDefinition = {
  retracedId: 'has_facility_acted_against_legal_requirements_hiring_temporary',
  name: 'Has the facility acted against legal requirements by hiring temporary/probationary/trainee/fixed-term contract workers t',
  description:
    "The intent of this question is to understand if the facility's hiring practices around short-term labor could be seen as the facility trying to avoid certain legal obligations. ",
  meta: {
    slcpMeta: {
      key: 'ep-7',
      number: 'RH-EMP-27',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ep-7', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27040,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
